import * as Types from '../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type NewInvitationSubscriptionVariables = Types.Exact<{
  userId: Types.Scalars['String']['input'];
}>;


export type NewInvitationSubscription = { __typename?: 'Subscription', inviteAdded?: { __typename?: 'Invite', fromUser: { __typename?: 'User', id: string, username: string, email?: string | null, firstName?: string | null, lastName?: string | null } } | null };


export const NewInvitationDocument = gql`
    subscription NewInvitation($userId: String!) {
  inviteAdded(userId: $userId) {
    fromUser {
      id
      username
      email
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useNewInvitationSubscription__
 *
 * To run a query within a React component, call `useNewInvitationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewInvitationSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewInvitationSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useNewInvitationSubscription(baseOptions: Apollo.SubscriptionHookOptions<NewInvitationSubscription, NewInvitationSubscriptionVariables> & ({ variables: NewInvitationSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NewInvitationSubscription, NewInvitationSubscriptionVariables>(NewInvitationDocument, options);
      }
export type NewInvitationSubscriptionHookResult = ReturnType<typeof useNewInvitationSubscription>;
export type NewInvitationSubscriptionResult = Apollo.SubscriptionResult<NewInvitationSubscription>;